export enum ConnectionStatus {
    NotSet = -1,
    Disconnected = 0,
    Connected = 1,
    Reconnecting = 2,
    TempDisconnect = 3,
}
